<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.details" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </div>
      <template #extra>
        <vxe-button content="button.reset" icon="vxe-icon-undo" mode="text" status="danger" @click="refresh(item.id)"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="item" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemNo')" prop="no">
              <a-input v-model="item.no" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.ChineseName')" prop="name">
              <a-input v-model="item.name" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.englishName')">
              <a-input v-model="item.englishName" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.universalName')">
              <a-input v-model="item.universalName" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storer')">
              <vxe-select v-model="storerIds" :options="storers" clearable multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.manufacturer')" prop="manufacturer">
              <a-input v-model="item.manufacturer" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.producingArea')">
              <a-input v-model="item.producingArea" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.approvalNo')">
              <a-input v-model="item.approval" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.license')">
              <a-input v-model="item.license" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.permission')">
              <a-input v-model="item.permission" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.practice')">
              <a-input v-model="item.practice" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.quality')">
              <a-input v-model="item.quality" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemBarcode')">
              <a-input v-model="item.barcodes" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.permitHolder')">
              <a-input v-model="item.permitHolder" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.patentNum')">
              <a-input v-model="item.patentNum" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.patentDay')">
              <a-input v-model="item.patentDay" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemType')" prop="itemType">
              <a-select v-model="item.itemType.id" :options="itemTypes" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemCategory')" prop="itemCategory">
              <a-select v-model="item.itemCategory.id" :options="itemCategories" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.legalAttribute')">
              <a-select v-model="item.legalAttribute.id" :options="legalAttributes" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.brand')">
              <a-select v-model="item.brand.id" :options="brands" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.season')">
              <a-select v-model="item.season.id" :options="seasons" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.dataSource')" prop="dataSource">
              <vxe-select v-model="item.dataSource" :options="dataSources" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.abcClassification')" prop="saleClassification">
              <a-select v-model="item.saleClassification" :options="saleClassifications" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storageClassification')" prop="storageClassification">
              <a-select v-model="item.storageClassification" :options="storageClassifications" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.turnoverMode')" prop="turnoverMode">
              <a-select v-model="item.turnoverMode" :options="turnoverModes" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storageEnvironment')">
              <a-select v-model="item.storageEnvironment" :options="storageEnvironments" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storageRequest')">
              <a-select v-model="item.storageRequest.id" :options="storageRequests" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.dosageForm')">
              <a-select v-model="item.dosageForm.id" :options="dosageForms" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.roundingMode')">
              <a-select v-model="item.roundingMode" allowClear>
                <a-select-option :value=2>向上取整</a-select-option>
                <a-select-option :value=3>向下取整</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supervisionCodeInitial')">
              <a-input v-model="item.supervisingBarcodeInitial" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supervisionCodeLength')">
              <a-input v-model="item.supervisingBarcodeLength" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.outboundNumberOfLot')">
              <a-input v-model="item.numberOfLot" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supplyQuantity')">
              <a-input v-model="item.numberOfSupply" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfProductionNearly')">
              <a-input v-model="item.daysOfProductionNearly" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfExpirationNearly')">
              <a-input v-model="item.daysOfExpirationNearly" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfInspectionNearly')">
              <a-input v-model="item.daysOfInspectionNearly" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfMaintenanceNearly')">
              <a-input v-model="item.daysOfMaintenanceNearly" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.separationOfLabel')">
              <a-input v-model="item.separationOfLabel" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.deviation')">
              <a-input v-model="item.deviation" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.tagPrice')">
              <a-input v-model="item.tagPrice" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.retailPrice')">
              <a-input v-model="item.retailPrice" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.wholesalePrice')">
              <a-input v-model="item.wholesalePrice" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.costPrice')">
              <a-input v-model="item.costPrice" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.purchasePrice')">
              <a-input v-model="item.purchasePrice" allowClear/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.available')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.available" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.approved')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.approved" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.newProduct')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.newProduct" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.coldStorage')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.refrigeration" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.valuable')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.valuable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.importation')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.importation" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.psychotropic')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.psychotropic" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.psychotropic2')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.psychotropic2" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.special')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.special" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.specialIngredient')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.specialIngredient" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.peptides')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.peptides" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.gift')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.gift" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.abnormality')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.abnormality" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.fragile')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.fragile" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.hazardous')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.hazardous" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.liquid')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.liquid" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.fallible')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.fallible" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.perishable')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.perishable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.approvalConfirm')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.approvalConfirm" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.lotControl')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.lotControl" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.autoAccepting')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.autoAccepting" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.autoPutaway')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.autoPutaway" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.scattered')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.scattered" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.duplex')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.duplex" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.visualized')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.visualized" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.supervised')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.supervised" size="mini"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="12">
            <a-form-model-item :label="$t('business.label.storageNotes')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <a-input v-model="item.storageNotes" :autosize="{ minRows: 2 }" allowClear type="textarea"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('business.label.checkContents')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <a-input v-model="item.checkContents" :autosize="{ minRows: 2 }" allowClear type="textarea"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
  </div>
</template>
<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'

export default {
  name: 'ItemDetail',
  data() {
    return {
      loading: false,
      enterprise: Vue.ls.get(ENTERPRISE),
      item: new Item(),
      storerIds: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        manufacturer: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        itemType: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        itemCategory: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        saleClassification: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        storageClassification: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        turnoverMode: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    storers: {
      type: Array,
      default: []
    },
    itemTypes: {
      type: Array,
      default: []
    },
    itemCategories: {
      type: Array,
      default: []
    },
    legalAttributes: {
      type: Array,
      default: []
    },
    brands: {
      type: Array,
      default: []
    },
    seasons: {
      type: Array,
      default: []
    },
    dataSources: {
      type: Array,
      default: []
    },
    saleClassifications: {
      type: Array,
      default: []
    },
    storageClassifications: {
      type: Array,
      default: []
    },
    turnoverModes: {
      type: Array,
      default: []
    },
    storageEnvironments: {
      type: Array,
      default: []
    },
    storageRequests: {
      type: Array,
      default: []
    },
    dosageForms: {
      type: Array,
      default: []
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(id, copy) {
      this.loading = true
      findOne('itemFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.item = new Item(res.result)
          this.storerIds = res.result.storers.map(item => item.id)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.item = new Item()
      this.item.available = true
      this.item.approved = true
      this.item.dataSource = 4
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const item = this.item.toJSONObject()
          item.enterprise = this.enterprise
          item.storers = this.storerIds.map(item => {
            return { id: item }
          })
          save('itemPersister', item).then(res => {
            if (res.success) {
              this.item = new Item(res.result)
              this.storerIds = res.result.storers.map(item => item.id)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>